import { Router, UrlTree } from "@angular/router";
import { UserNavigationMenuItem } from "../../navigation/navigation-menu.models";

export const ROLE_ASSIGNMENT_REQUIRED_ROUTE = ["/role-assignment-required"];

/**
 * Selects the first destination in the authenticated user's navigation menu.
 * Passing the menu and router in allows access guards to use the same helper after determining
 * that the user has a recognized role.
 */
export function resolveLandingPageUrl(userNavigationMenu: readonly UserNavigationMenuItem[], router: Router): UrlTree {
    const firstAccessibleMenuItem = userNavigationMenu.at(0);

    return router.createUrlTree(firstAccessibleMenuItem?.route ?? ROLE_ASSIGNMENT_REQUIRED_ROUTE);
}
